<template>
  <div id="page" class="container-fluid">
    <div class="row header mx-4 my-4">
      <div class="col my-3">
        <h1> {{ allowableFeeScheduleCodes.feeScheduleName}}
          <b-button class="ml-3" variant="outline-orange" @click="addAllowableFeeScheduleCode()">
          <font-awesome-icon class="orange" icon="plus"/>
          New
        </b-button></h1>
      </div>
      <div class="row mt-3">
        <div class="patient-search-section">
        <b-input-group class="patient-search-border text-right">
          <b-form-input ref="searchInput"
                        placeholder="Search (Code)"
                        class="patient-search"
                        v-model="searchTerm">

          </b-form-input>
          <b-input-group-append>
            <button class="btn btn-default search-submit" type="button">
              <font-awesome-icon icon="search"/>
            </button>
          </b-input-group-append>
        </b-input-group>
          </div>
        </div>
    </div>
    <div class="container-fluid">
      <div class="row data-table-header">
        <div class="col-1">Code</div>
        <div class="col-1">Modifier</div>
        <div class="col-2">Discount Eligible</div>
        <div class="col-2">Facility Fee</div>
        <div class="col-2">Non Facility Fee</div>
        <div class="col-2">Medicare Multiplier</div>
        <div class="col-2"></div>
      </div>
      <div v-for="allowableFeeScheduleCode in filteredCodes" class="row data-table-row" :key="allowableFeeScheduleCode.organizationAllowableFeeScheduleCodeId">
        <div class="column col-1">{{ allowableFeeScheduleCode.code }}</div>
        <div class="column col-1">{{ allowableFeeScheduleCode.modifier }}</div>
        <div class="column col-2">{{discountEligible(allowableFeeScheduleCode.discountEligible)}}</div>
        <div class="column col-2">{{allowableFeeScheduleCode.facilityFee !== null ? '$' + formatNumber(allowableFeeScheduleCode.facilityFee) : ' '}}</div>
        <div class="column col-2">{{allowableFeeScheduleCode.nonFacilityFee !== null ? '$' + formatNumber(allowableFeeScheduleCode.nonFacilityFee) : ' '}}</div>
        <div class="column col-2">{{formatPercent(allowableFeeScheduleCode.medicareMultiplier)}}</div>
        <div class="col-2 text-right">
          <button title="Edit" @click.prevent="editAllowableFeeScheduleCode(allowableFeeScheduleCode)" type="button" class="btn btn-outline-orange m-1 wide-button">
            <font-awesome-icon class="orange mr-2" :icon="['far', 'edit']"/>Edit
          </button>
          <button title="Delete" @click.prevent="confirmDelete(allowableFeeScheduleCode.organizationAllowableFeeScheduleCodeId)" type="button" class="btn btn-outline-orange m-1 wide-button">
            <font-awesome-icon class="orange mr-2" :icon="['far', 'trash-alt']"/>Delete
          </button>
        </div>
      </div>
    </div>
    <allowable-fee-schedule-codes-modal :allowable-fee-schedule-id="id" :edit-allowable-fee-schedule-code="editingAllowableFeeScheduleCode" @updated="allowableFeeScheduleCodeUpdated" :visible="showingAllowableFeeScheduleCodeModal"
                                  @update:visible="visible => showingAllowableFeeScheduleCodeModal = visible"></allowable-fee-schedule-codes-modal>

    <confirm-modal :title="confirmTitle"
                   @confirmed="deleteConfirmed"
                   confirmButton="Delete"
                   :copy="confirmCopy"
                   :visible="showConfirmation"
                   @update:visible="visible => showConfirmation = visible"></confirm-modal>
    <loading-modal :visible="showingLoadingModal" :return-focus="$refs.searchInput"
                   @update:visible="visible => showingLoadingModal = visible"></loading-modal>
    <paginator :totalPages="totalPages" :currentPage="currentPage" @update:currentPage="newPage => currentPage = newPage"></paginator>
  </div>
</template>

<script>
  import AllowableFeeScheduleCodesModal from '@/components/AllowableFeeScheduleCodesModal'
  import api from '@/services/api'
  import ConfirmModal from '@/components/ConfirmModal'
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import Paginator from '@/components/Paginator'
  import LoadingModal from '@/components/LoadingModal'
  import _ from 'lodash'

  export default {
    name: 'AllowableFeeSchedulesCodes',

    components: { LoadingModal, Paginator, AllowableFeeScheduleCodesModal, ConfirmModal },

    mixins: [ErrorsMixin],

    props: {
      id: {
        type: Number,
        required: true
      }
    },

    data () {
      return {
        isLoading: false,
        errors: [],
        showingAllowableFeeScheduleCodeModal: false,
        editingAllowableFeeScheduleCode: {},
        totalPages: 0,
        currentPage: 1,
        pageSize: 20,
        searchTerm: '',
        confirmingDelete: true,
        showConfirmation: false,
        feeScheduleCodeId: 0,
        feeScheduleId: 0,
        showingLoadingModal: false,
        allowableFeeScheduleCodes: {
          codes: []
        },
        matchedCodes: {
          codes: []
        }
      }
    },
    methods: {
      loadData (silent = false) {
        if (!silent) {
          this.showingLoadingModal = true
        }
        const parameters = {
          pageSize: this.pageSize,
          page: this.currentPage,
          organizationAllowableFeeScheduleId: this.id
        }
        api.post('Dashboard/AllowableFeeSchedules/' + this.id + '/CodeList', parameters).then(response => {
          this.allowableFeeScheduleCodes = response.data
          this.currentPage = response.data.page
          this.totalPages = Math.ceil(response.data.totalCodes / this.pageSize)
          this.showingLoadingModal = false
          this.searchCodes()
        }).catch(error => {
          this.isSaving = false
          this.showingLoadingModal = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
          }
        })
      },
      addAllowableFeeScheduleCode () {
        this.editingAllowableFeeScheduleCode = {}
        this.showingAllowableFeeScheduleCodeModal = true
      },

      editAllowableFeeScheduleCode (allowableFeeScheduleCode) {
        this.editingAllowableFeeScheduleCode = allowableFeeScheduleCode
        this.showingAllowableFeeScheduleCodeModal = true
      },
      allowableFeeScheduleCodeUpdated () {
        this.showingAllowableFeeScheduleCodeModal = false
        this.loadData()
      },
      confirmDelete (codeId) {
        this.showConfirmation = true
        this.feeScheduleCodeId = codeId
      },
      deleteFeeSchedule () {
        if (this.confirmingDelete) {
          api.delete('Dashboard/AllowableFeeSchedules/Codes/' + this.feeScheduleCodeId).then(() => {
            this.loadData()
          }).catch(error => {
            this.isSaving = false
            if (!this.$store.canHandleNetworkError(error)) {
              this.setFromApiErrorResponse(error)
            }
          })
          this.feeScheduleCodeId = 0
        }
      },
      deleteConfirmed (confirmation) {
        this.showConfirmation = false
        if (confirmation === true) {
          this.deleteFeeSchedule()
        }
      },
      searchCodes () {
        if (!this.searchTerm) {
          this.matchedCodes = []
          return
        }

        const parameters = {
          searchTerm: this.searchTerm,
          organizationAllowableFeeScheduleId: this.id
        }

        api.post('/Dashboard/AllowableFeeSchedules/CodeSearch', parameters).then(response => {

          this.matchedCodes = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to search for code: ' + error.message, error)
          }
        })
      },
      formatNumber (number) {
        if (number === 0 || number === 0.0) {
          return '0.00'
        }
        if (number) {
          return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }

        return ''
      },
      discountEligible (eligible) {
        if (eligible === true) {
          return 'Yes'
        }
        if (eligible === false) {
          return 'No'
        }
      },

      formatPercent (number) {
        if (number) {
          return number * 100 + '%'
        }
      }
    },
    watch: {
      searchTerm: _.debounce(function (searchTerm) {
        if (searchTerm === '') {
          this.totalPages = Math.ceil(this.allowableFeeScheduleCodes.totalCodes / this.pageSize)
          this.currentPage = 1
        } else {
          this.currentPage = 1
          this.totalPages = 0
        }
        this.searchCodes()
      }, 500),
      id (newValue) {
        if (newValue) {
          this.feeScheduleId = newValue
        }
      },
      currentPage (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.loadData()
        }
      }
    },
    computed: {
      filteredCodes () {
        if (this.searchTerm) {
          return this.matchedCodes.codes
        } else {
          return this.allowableFeeScheduleCodes.codes
        }
      },
      confirmTitle () {
        return 'Delete Fee Schedule Code'
      },

      confirmButton () {
        if (this.confirmingDelete) {
          return 'Void'
        } else {
          return 'Check In'
        }

      },
      confirmCopy () {
        if (this.confirmingDelete) {
          return 'Are you sure you want to delete this fee schedule code?'
        }
        return ''
      }
    },

    created () {
      this.loadData()
    }
  }

</script>
<style scoped>
.patient-search-border {
  border: 1px solid rgb(255, 70, 0);
  border-radius: 5px;
}

.patient-search {
  border: none;
  border-radius: 4px 0 0 4px;
  box-shadow: none;
  padding-right: 0px;
  min-width: 220px;
  height: 36px;
}
</style>
